module.exports = __webpack_public_path__ + "static/media/empty_data_salary.79221d5e.png";